module.exports = __webpack_public_path__ + "5f6ca4d04bfb756731d6d714b6fc057e.ttf";